import type { UseFormReturnType } from "@mantine/form";

import { Autocomplete, InputLabel, Loader } from "@mantine/core";

import type { CollectCustomerInfoFormData } from "../../hooks/useCollectCustomerInfoForm";

import { MapIcon } from "../Icons/MapIcon";
import { AddressNotFound } from "./AddressNotFound";
import classes from "./CollectCustomerInfo.module.css";

type AutoAddressInputProps = {
    form: UseFormReturnType<CollectCustomerInfoFormData>;
    isLoading: boolean;
    addressSuggestions: { value: string; label: string }[];
    showAddressNotFoundMessage: boolean;
    onAddAddressManually: () => void;
    onAddressSelect: (placeId: string) => void;
};

export const AutoAddressInput = ({
    form,
    isLoading,
    addressSuggestions,
    showAddressNotFoundMessage,
    onAddAddressManually,
    onAddressSelect,
}: AutoAddressInputProps) => {
    return (
        <>
            <InputLabel size="xs">Home address</InputLabel>

            <Autocomplete
                aria-label="Home address"
                className="fs-mask"
                mt="3xs"
                id="customer-address-input"
                size="sm"
                fz="xs"
                classNames={{ input: classes.styledInput }}
                data={addressSuggestions}
                error={form.errors.addressSearch}
                leftSection={<MapIcon />}
                rightSection={isLoading ? <Loader size={16} /> : null}
                autoComplete="off"
                filter={({ options }) => options}
                // Option values are place ids. Mantine fills the input with the label, and the select handler
                // swaps in the full address once it resolves.
                onOptionSubmit={onAddressSelect}
                {...form.getInputProps("addressSearch")}
            />

            {showAddressNotFoundMessage && <AddressNotFound onAddAddressManually={onAddAddressManually} />}
        </>
    );
};
